<template>
  <v-card flat class="visibility-settings pa-4 pa-md-5" :class="{ 'visibility-settings--embedded': embedded }">
    <v-card-title class="px-0 pt-0">
      <div>
        <div class="headline">Public catalogue</div>
        <div class="caption grey--text">Controls whether this record is published in the collection catalogue.</div>
      </div>
    </v-card-title>

    <v-alert
      v-if="inheritedHidden"
      :value="true"
      type="info"
      outline
      class="mb-4"
    >
      Artist is hidden from catalogue. This artwork and its public detail page are hidden automatically.
    </v-alert>

    <v-layout align-center class="visibility-control px-3 py-2">
      <div>
        <div class="subheading">Hide on public website</div>
        <div class="caption grey--text">Removes the record from listings, search results, and its public URL.</div>
      </div>
      <v-spacer></v-spacer>
      <v-switch
        v-model="hidden"
        color="black"
        hide-details
        :disabled="saving || copyrightSaving || inheritedHidden || !c_user.edit"
        :loading="saving"
        @change="save"
      ></v-switch>
    </v-layout>

    <v-layout v-if="artist" align-center class="visibility-control copyright-control px-3 py-2 mt-3">
      <div>
        <div class="subheading">Annual copyright credit</div>
        <div class="caption grey--text">Show the image society copyright credit on all of this artist's catalogue artworks.</div>
        <router-link to="/public-settings" class="copyright-settings-link">Manage English and Spanish credit text</router-link>
      </div>
      <v-spacer></v-spacer>
      <v-switch
        v-model="annualCopyrightEnabled"
        color="black"
        hide-details
        aria-label="Annual copyright credit"
        :disabled="saving || copyrightSaving || !c_user.edit"
        :loading="copyrightSaving"
        @change="saveAnnualCopyright"
      ></v-switch>
    </v-layout>

    <v-snackbar v-model="snackbar" right top :color="snackbarColor" :timeout="4000">
      {{ snackbarText }}
      <v-btn flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import axios from '@/utils/apiClient'

export default {
  name: 'VisibilitySettings',
  props: {
    artwork: { type: Object, default: null },
    artist: { type: Object, default: null },
    embedded: { type: Boolean, default: false }
  },
  data () {
    const record = this.artwork || this.artist

    return {
      hidden: record ? Boolean(record.hidden_from_catalogue) : false,
      annualCopyrightEnabled: record ? record.annual_copyright_credit_enabled === true || Number(record.annual_copyright_credit_enabled) === 1 : false,
      copyrightSaving: false,
      saving: false,
      snackbar: false,
      snackbarColor: 'black',
      snackbarText: ''
    }
  },
  computed: {
    record () {
      return this.artwork || this.artist
    },
    recordType () {
      return this.artwork ? 'artwork' : 'artist'
    },
    inheritedHidden () {
      return Boolean(this.artwork && this.artwork.catalogue_artist_hidden)
    }
  },
  watch: {
    record: {
      deep: true,
      handler (record) {
        if (record) {
          this.hidden = Boolean(record.hidden_from_catalogue)
          this.annualCopyrightEnabled = record.annual_copyright_credit_enabled === true || Number(record.annual_copyright_credit_enabled) === 1
        }
      }
    }
  },
  methods: {
    saveAnnualCopyright () {
      if (!this.artist || !this.c_user.edit || this.saving || this.copyrightSaving) return

      const previous = this.artist.annual_copyright_credit_enabled === true || Number(this.artist.annual_copyright_credit_enabled) === 1
      const enabled = this.annualCopyrightEnabled
      this.copyrightSaving = true
      return axios.patch(`${this.$globals.apiserver}/artists/${this.artist.id}.json`, {
        annual_copyright_credit_enabled: enabled
      })
        .then(() => {
          this.$set(this.artist, 'annual_copyright_credit_enabled', enabled)
          this.notify('Annual copyright credit saved.', 'black')
        })
        .catch(() => {
          this.annualCopyrightEnabled = previous
          this.notify('Could not save annual copyright credit.', 'red')
        })
        .then(() => { this.copyrightSaving = false })
    },
    save () {
      if (!this.record || this.inheritedHidden) return

      const previous = Boolean(this.record.hidden_from_catalogue)
      const url = `${this.$globals.apiserver}/${this.recordType}s/${this.record.id}.json`
      const data = this.artwork
        ? { artwork: { hidden_from_catalogue: this.hidden } }
        : { hidden_from_catalogue: this.hidden }

      this.saving = true
      axios.patch(url, data)
        .then(() => {
          this.$set(this.record, 'hidden_from_catalogue', this.hidden)
          this.notify('Catalogue visibility saved.', 'black')
        })
        .catch(() => {
          this.hidden = previous
          this.notify('Could not save catalogue visibility.', 'red')
        })
        .then(() => { this.saving = false })
    },
    notify (text, color) {
      this.snackbarText = text
      this.snackbarColor = color
      this.snackbar = true
    }
  }
}
</script>

<style scoped>
.visibility-settings { max-width: 900px; border-top: 1px solid #000; }
.visibility-settings--embedded { border-top: 0; max-width: none; }
.visibility-control { min-height: 84px; border: 1px solid #000; }
.copyright-settings-link { display: inline-block; margin-top: 6px; color: #333; text-decoration: underline; font-size: 12px; }
.copyright-control .v-input { flex: 0 0 auto; margin-left: 24px; }
</style>



// WEBPACK FOOTER //
// src/components/public/VisibilitySettings.vue